import * as yup from 'yup';

export const MSG_REQUIRED = 'Información obligatoria';
export const MSG_LT_PMP = 'El valor debe ser menor o igual al peso muestra pergamino';

const patternNumero2Decimales = /^\d+(\.\d{0,2})?$/;

export const validacionNumero2Decimales = yup
  .number()
  .transform(value => (isNaN(value) ? undefined : value))
  .min(0, 'se espera que sea mayor o igual a 0')
  .test('is-decimal', 'Solo se permiten dos decimales', val => {
    if (val != undefined) {
      return patternNumero2Decimales.test(val);
    }
    return true;
  });

export const validacionPuntajeSensorial = (valMin = 6.0, valMax = 10.0) =>
  yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .min(valMin, `Se espera un valor entre ${valMin} y ${valMax}`)
    .max(valMax, `Se espera un valor entre ${valMin} y ${valMax}`) 
    .test('dos-decimales', 'Solo se permiten dos decimales', (val) => {
      if (val === undefined || val === null) return true;
      return /^\d+(\.\d{1,2})?$/.test(String(val));
    })
    .test('intervalo-0.25', 'Solo se permiten .00, .25, .50, .75', (val) => {
      if (val === undefined || val === null) return true;
      return Number.isInteger(Math.round(val * 4));
    })
    .nullable();

export const zarandaDefectosSchema = {
  id_tipo_mancha: yup
    .number()
    .transform(value => {
      const n = Number(value);
      if (isNaN(n) || n === 0) return undefined;
      return n;
    })
    .min(1, 'Seleccione una opción')
    .nullable(),
  no_granos: validacionNumero2Decimales.min(0.01, 'se espera que sea mayor a 0').nullable(),
  defectos: validacionNumero2Decimales.min(0.01, 'se espera que sea mayor a 0').nullable(),
  eliminar: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
};

export const zarandaSchema = {
  id_zaranda: yup
    .number()
    .transform(value => {
      const n = Number(value);
      if (isNaN(n) || n === 0) return undefined;
      return n;
    })
    .min(1, 'Seleccione una opción')
    .nullable(),
  valor: validacionNumero2Decimales.min(0.01, 'se espera que sea mayor a 0').nullable(),
  eliminar: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
};

export const schema = yup.object().shape({
  info_muestra: yup.object().shape({
    id_calidad_analisis_fisico: yup.string().nullable(),
    id_calidad_analisis: yup.string().nullable(),
    id_muestra: yup.string().nullable(),
    fecha: yup.date().transform((curr, orig) => orig === '' ? null : curr).required(MSG_REQUIRED).nullable(),
    id_tipo_proceso: yup.number().transform(value => (isNaN(value) ? undefined : value)).min(1, MSG_REQUIRED).required(MSG_REQUIRED),
    id_tipo_muestra: yup.number().transform(value => (isNaN(value) ? undefined : value)).min(1, MSG_REQUIRED).required(MSG_REQUIRED),
    id_tipo_cafe: yup.number().transform(value => (isNaN(value) ? undefined : value)).min(1, MSG_REQUIRED).required(MSG_REQUIRED),
    id_cuenta: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    id_acopio: yup.string().nullable(),
    id_recoleccion_acopio: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    id_tipo_analisis: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    analisis_por_entrega: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    id_ciclo: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    nombre_proveedor: yup.string().nullable(),
    region_proveedor: yup.string().nullable(),
    notas_adicionales: yup.string().nullable(),
    observaciones: yup.string().nullable(),
    id_municipio: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    id_localidad: yup.string().nullable(),
    uuid_calidad_analisis: yup.string().nullable(),
  }),
  analisis_fisico: yup.object().shape({
    pergamino_peso_muestra_pergamino: validacionNumero2Decimales.min(0.01, MSG_REQUIRED).required(MSG_REQUIRED),
    pergamino_peso_muestra_oro: validacionNumero2Decimales.min(0.01, MSG_REQUIRED).max(yup.ref('pergamino_peso_muestra_pergamino'), MSG_LT_PMP).required(MSG_REQUIRED),
    pergamino_peso_mancha: validacionNumero2Decimales.lessThan(yup.ref('pergamino_peso_muestra_pergamino'), MSG_LT_PMP).nullable(),
    pergamino_densidad: validacionNumero2Decimales.min(0.01, MSG_REQUIRED).nullable(),
    pergamino_humedad: validacionNumero2Decimales
      .min(0, 'se espera que sea mayor o igual a 0')
      .max(100, 'Se espera un valor menor o igual a 100')
      .required(MSG_REQUIRED),
    olor_muestra: yup.string().nullable(),
    pergamino_actividad_agua: validacionNumero2Decimales.min(0.01, MSG_REQUIRED).nullable(),
    id_color_muestra: yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable(),
    uuid_calidad_analisis_fisico: yup.string().nullable(),
  }),
  analisis_oro: yup.object().shape({
    pergamino_peso_muestra_oro_2: validacionNumero2Decimales
      .transform(value => (isNaN(value) ? undefined : value))
      .nullable(),
    total_defectos_gramos: validacionNumero2Decimales
      .transform(value => (isNaN(value) ? undefined : value))
      .min(0, 'se espera que sea mayor o igual a 0')
      .when('pergamino_peso_muestra_oro_2', (oro2, schema) => (oro2 ? schema.lessThan(yup.ref('pergamino_peso_muestra_oro_2'), 'Debe ser menor al peso de la muestra oro') : schema))
      .nullable(),
    peso_cafe_limpio_grs: validacionNumero2Decimales
      .transform(value => (isNaN(value) ? undefined : value))
      .min(0, 'se espera que sea mayor o igual a 0')
      .when('pergamino_peso_muestra_oro_2', (oro2, schema) => (oro2 ? schema.lessThan(yup.ref('pergamino_peso_muestra_oro_2'), 'Debe ser menor al peso de la muestra oro') : schema))
      .nullable(),
    rendimiento_exportable_por: validacionNumero2Decimales
      .transform(value => (isNaN(value) ? undefined : value))
      .min(0, 'se espera que sea mayor o igual a 0')
      .lessThan(100, 'Se espera un valor menor a 100')
      .nullable(),
    perdida_procesamiento_por: validacionNumero2Decimales
      .transform(value => (isNaN(value) ? undefined : value))
      .min(0, 'se espera que sea mayor o igual a 0')
      .lessThan(100, 'Se espera un valor menor a 100')
      .nullable(),
    zarandas: yup.array().of(yup.object().shape(zarandaSchema)),
    defectos_primarios: yup.array().of(yup.object().shape(zarandaDefectosSchema)),
    defectos_secundarios: yup.array().of(yup.object().shape(zarandaDefectosSchema)),
  }),
  analisis_sensorial: yup.object().shape({
    id_calidad_analisis_sensorial: yup.string().nullable(),
    perfil_taza: yup.string().nullable(),
    fragancia_aroma: validacionPuntajeSensorial(),
    fragancia_aroma_desc: yup.string().nullable(),
    sabor: validacionPuntajeSensorial(),
    sabor_desc: yup.string().nullable(),
    sabor_residual: validacionPuntajeSensorial(),
    sabor_residual_desc: yup.string().nullable(),
    acidez: validacionPuntajeSensorial(),
    acidez_desc: yup.string().nullable(),
    cuerpo: validacionPuntajeSensorial(),
    cuerpo_desc: yup.string().nullable(),
    balance: validacionPuntajeSensorial(),
    balance_desc: yup.string().nullable(),
    uniformidad: validacionPuntajeSensorial(0,5),
    uniformidad_desc: yup.string().nullable(),
    taza_limpia: validacionPuntajeSensorial(0,5),
    taza_limpia_desc: yup.string().nullable(),
    dulzor: validacionPuntajeSensorial(0,5),
    dulzor_desc: yup.string().nullable(),
    puntaje_calculado: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(0, 'Se espera un valor mayor o igual a 0')
      .nullable(),
    puntaje_manual: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(0, 'Se espera un valor mayor o igual a 0')
      .max(100, 'Se espera un valor menor o igual a 100')
      .test('dos-decimales', 'Solo se permiten dos decimales', (val) => {
        if (val === undefined || val === null) return true;
        return /^\d+(\.\d{1,2})?$/.test(String(val));
      })
      .test('intervalo-0.25', 'Solo se permiten .00, .25, .50, .75', (val) => {
        if (val === undefined || val === null) return true;
        return Number.isInteger(Math.round(val * 4));
      })
      .nullable(),
    defectos_no_tazas: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(0, 'Se espera un valor entre 0 y 5')
      .max(5, 'Se espera un valor entre 0 y 5')
      .integer('Debe ser un número entero')
      .nullable(),
    defectos_intensidad: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .test('dos-o-cuatro', 'Solo se permite 2 o 4', (val) => {
        if (val === undefined || val === null) return true;
        return val === 2 || val === 4;
      })
      .nullable(),
    catador: validacionPuntajeSensorial(),
    catador_desc: yup.string().nullable(),
    uuid_calidad_analisis_sensorial: yup.string().nullable(),
  }),
});
